import { useSelector } from "react-redux";
import {
  ListUsersForAccountApiArg,
  useListUsersForAccountQuery,
  V1UserResource,
  V1TeamResource,
} from "../../../../services/generated";

import { RootState } from "@reducers/rootReducer";

export interface HookArgs {
  page?: ListUsersForAccountApiArg["page"];
  filter?: ListUsersForAccountApiArg["filter"];
}

const useListUsers = ({ page, filter }: HookArgs) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, error, isLoading, refetch } = useListUsersForAccountQuery({
    slug: accountSlug,
    page,
    filter,
    include: ["teams"],
  });

  let user: V1UserResource[] = [];
  let team: V1TeamResource[] = [];

  let customError: string | null = null;
  let pageMeta = {
    "record-count": 0,
    "page-count": 0,
  };

  if (data?.data) {
    try {
      user = data.data;
      team = (data.included || []).filter(
        (item): item is V1TeamResource => item.type === "teams"
      );
      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        "record-count": data.meta["record-count"],
        "page-count": data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    data: user,
    team,
    error: error || customError,
    isLoading,
    pageMeta,
    refetch,
  };
};

export default useListUsers;
